import script from "./UserBreakdownChart.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBreakdownChart.vue?vue&type=script&setup=true&lang=js"

import "./UserBreakdownChart.vue?vue&type=style&index=0&id=3073617f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3073617f"]])

export default __exports__